import Vue from "vue";
import VueRouter from "vue-router";
import { authGet } from "../helpers/authStorage";

const Dashboard = () => import("../views/content/contenedor/Contenedor.vue");
const Home = () => import("../views/content/dashboard/Dashboard.vue");
const AttributeVenta = () =>
  import("../components/AttributeVenta/AttributeVenta.vue");
const AttributeUser = () =>
  import("../components/AttributeUser/AttributeUser.vue");
const AttributeCourse = () =>
  import("../components/AttributeCourse/AttributeCourse.vue");
const Courses = () => import("../views/content/courses/Courses.vue");
const Suscription = () =>
  import("../views/content/suscriptions/Suscriptions.vue");
const ProductorCourses = () =>
  import("../views/content/productorCourses/ProductorCourses.vue");
const Messages = () => import("../views/content/message/Messages.vue");
const CursoUser = () => import("../views/content/course/Course.vue");
const ViewBook = () => import("../views/content/book/ViewBook.vue");
const Login = () => import("../views/auth/Login.vue");
const Perfil = () => import("../views/content/perfil/Perfil.vue");
const buycursos = () => import("../components/courses/buy-cursos.vue");
const buybooks = () => import("../components/courses/buy-books.vue");
const Certificado = () => import("../components/Certificado/certificado.vue");
const detalleCertificado = () =>
  import("../components/Certificado/detalleCertificado.vue");
const pruebasCourse = () =>
  import("../components/course/descripcion/pruebas/pruebasCourse.vue");
const DinamicClass = () =>
  import("../components/course/descripcion/dinamics/view/DinamicClass.vue");
const logrosUser = () => import("../components/LogrosUser/Logros.vue");
const examenes = () => import("../components/examenes/examenes.vue");
const preguntasFrecuentes = () => import("../components/preguntasFrecuentes");
const leaderBoard = () =>
  import("../components/LeaderBoardUser/LeaderBoard.vue");
const optionPreference = () =>
  import("../views/content/optionpreferences/OptionPreferences.vue");
const Buy = () => import("../views/content/buy/buy.vue");
const BuyCertificate = () => import("../views/content/buy/buyCertificate.vue");
const Search = () => import("../views/content/search/Search.vue");
const PasswordRecovery = () =>
  import("../views/content/passwordRecovery/index.vue");
const pruebaJuego = () => import("../views/content/pruebaJuego.vue");
const AutoLogin = () => import("../views/content/AutoLogin.vue");
const Conector = () => import("../views/content/Conector.vue");
const CartPage = () => import("../views/content/cart/Cart.vue");
const WishlistPage = () => import("../views/content/wishlist/Wishlist.vue");
const CourseLanding = () => import("../views/public/CourseLanding.vue");
const DistributorLanding = () => import("../views/public/DistributorLanding.vue");

// import PreferencesCateg from '../views/content/preferences/PreferenceCateg.vue'
// import Suscription from '../components/suscription/suscription.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "home",
        component: Home,
        meta: { autenticado: false },
      },
      {
        path: "home",
        redirect: { name: "home" },
      },
      {
        path: "courses",
        name: "courses",
        component: Courses,
        meta: { autenticado: false },
      },
      {
        path: "buy-cursos/:ide/:slug", // El ? hace que title sea opcional
        name: "buy-cursos",
        component: buycursos,
        props: true,
        meta: { autenticado: false },
      },
      {
        path: "buy-books/:ide/:slug",
        name: "buy-books",
        component: buybooks,
        props: true,
        meta: { autenticado: false },
      },
      {
        path: "/course-user",
        component: CursoUser,
        name: "curso",
        props: true,
        meta: { autenticado: false },
      },
      {
        path: "/book/:id",
        component: ViewBook,
        name: "book",
        props: true,
        meta: { autenticado: true },
      },
      { path: "/test/:id", component: pruebasCourse, name: "test", meta: { autenticado: true } },
      {
        path: "/course-user/dinamic/:id",
        component: DinamicClass,
        name: "dinamic",
        props: true,
        meta: { autenticado: true },
      },
      {
        path: "cart",
        name: "cart",
        component: CartPage,
        meta: { autenticado: true },
      },
      {
        path: "wishlist",
        name: "wishlist",
        component: WishlistPage,
        meta: { autenticado: true },
      },
      { path: "/messages", component: Messages, name: "messages", meta: { autenticado: true } },
      {
        path: "/attribute-user/:id",
        name: "attribute-user",
        component: AttributeUser,
        meta: { autenticado: true },
      },
      {
        path: "/attribute-course",
        name: "attribute-course",
        component: AttributeCourse,
        meta: { autenticado: true },
      },
      { path: "/perfil", name: "perfil", component: Perfil, meta: { autenticado: true } },
      {
        path: "/option-preferences",
        name: "option-preferences",
        component: optionPreference,
        meta: { autenticado: true },
      },
      {
        path: "/suscription-user",
        component: Suscription,
        name: "suscription-user",
        meta: { autenticado: true },
      },
      {
        path: "/certificado-user",
        name: "certificado-user",
        component: Certificado,
        meta: { autenticado: true },
      },
      {
        path: "/detalle-certificado",
        name: "detalle-certificado",
        component: detalleCertificado,
        meta: { autenticado: true },
      },
      { path: "/logros", name: "logros", component: logrosUser, meta: { autenticado: true } },
      {
        path: "/preguntas-frecuentes",
        name: "preguntas-frecuentes",
        component: preguntasFrecuentes,
        meta: { autenticado: false },
      },
      { path: "/leaderBoard", name: "leaderBoard", component: leaderBoard, meta: { autenticado: true } },
      { path: "/buy/:ide", name: "buy", component: Buy, meta: { autenticado: true } },
      {
        path: "/buyCertificate/:courseId",
        name: "buyCertificate",
        component: BuyCertificate,
        props: true,
        meta: { autenticado: true },
      },
      { path: "/course/search/", name: "search", component: Search, meta: { autenticado: false } },
      { path: "/my-courses/", name: "myCourses", component: ProductorCourses, meta: { autenticado: true } },
      {
        path: "/panel-distribuidor",
        name: "PanelDistribuidor",
        component: () =>
          import(
            /* webpackChunkName: "PanelDistribuidor" */ "../views/content/distributor/PanelDistribuidor.vue"
          ),
        meta: {
          requiresAuth: true,
          roles: [1, 2, 4],
        },
      },
      {
        path: "/panel-distribuidor/curso/:id",
        name: "PanelDistribuidorCurso",
        component: () =>
          import(
            /* webpackChunkName: "PanelDistribuidorCurso" */ "../views/content/distributor/PanelDistribuidorCurso.vue"
          ),
        meta: {
          requiresAuth: true,
          roles: [1, 2, 4],
        },
      },
      { path: "/examenes/", name: "examenes", component: examenes, meta: { autenticado: true } },
      {
        path: "/mode/:mode/:productSlug/clase/:slug",
        component: CursoUser,
        name: "preview",
        meta: { title: "- Previsualización", autenticado: false },
      },
      {
        path: "/owlgame",
        name: "owlgame",
        component: pruebaJuego,
        props: true,
        meta: { autenticado: true },
      },
    ],
  },

  // { path: '/marketplace', component: Courses, name: 'marketplace',meta:{autenticado:false}},
  { path: "/login", name: "Login", component: Login },
  { path: "/attribute", name: "attribute", component: AttributeVenta },
  {
    path: "/contrasena",
    name: "passwordrecovery",
    component: PasswordRecovery,
  },
  { path: "/prueba-juego", name: "pruebaJuego", component: pruebaJuego },
  {
    path: "/redirect/:value",
    name: "autoLogin",
    component: AutoLogin,
    props: true,
  },
  {
    path: "/conector/:value",
    name: "conector",
    component: Conector,
    props: true,
  },
  {
    path: "/landing/course/:id",
    name: "course-landing",
    component: CourseLanding,
    meta: { autenticado: false },
  },
  {
    path: "/ref/:username",
    name: "distributor-landing",
    component: DistributorLanding,
    meta: { autenticado: false },
  },
  // { path: '/preferences', name: 'Preferences', component: PreferencesCateg, meta: { autenticado: true } },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Nota de seguridad: esta guarda es solo UX, NO es un control de seguridad.
// Cualquier valor en access_token la satisface. La autorización real debe
// validarse en cada endpoint del backend (auth:sanctum + policies).
router.beforeEach((to, from, next) => {
  let token = authGet("access_token");
  let autenticado = to.matched.some((record) => record.meta.autenticado);
  let exception = to.matched.some(
    (record) => record.meta.autenticado === false
  );
  // let status = localStorage.getItem('status_user')
  if (exception) {
    next();
  } else if (autenticado) {
    if (!token) {
      next("login");
    } else {
      next();
    }
  }
  //  if ((!autenticado && token) && status == 0 ) {
  //   next('/preferences');
  // else if ((!autenticado && token)) {
  //   next();

  // }
  else {
    next();
  }
});

export default router;
